(function () {
  if (window.CasaFloralProductUiLoaded) return;
  window.CasaFloralProductUiLoaded = true;

  function getDeliveryApi() {
    return window.CasaFloralDelivery;
  }

  function getPicker(selector) {
    return selector.closest('product-info')?.querySelector('#delivery_date_picker');
  }

  function getHiddenDeliveryInput(selector) {
    return selector.closest('product-info')?.querySelector('#hidden_delivery_date');
  }

  function setButtonContent(button, option) {
    const label = button.querySelector('[data-delivery-option-label]');
    const detail = button.querySelector('[data-delivery-option-detail]');

    if (label) label.textContent = option.label;
    if (detail) detail.textContent = option.shortDate;
    button.disabled = !option.available;
    button.dataset.deliveryDateValue = option.date
      ? getDeliveryApi().formatCalendarDateForInput(option.date)
      : '';
  }

  function updateSelectedOption(selector, preferredOption) {
    const selectedDate = getHiddenDeliveryInput(selector)?.value;
    const quickButtons = [...selector.querySelectorAll('[data-delivery-quick-option]')];
    const calendarButton = selector.querySelector('[data-delivery-calendar-option]');
    const matchingButton = quickButtons.find((button) => button.dataset.deliveryDateValue === selectedDate);
    const selectedButton = preferredOption === 'calendar' ? calendarButton : matchingButton ?? calendarButton;

    [...quickButtons, calendarButton].filter(Boolean).forEach((button) => {
      const isSelected = Boolean(selectedDate) && button === selectedButton;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
    });
  }

  function refreshDeliverySelector(selector) {
    const api = getDeliveryApi();
    if (!api) return;

    const productInfo = selector.closest('product-info');
    const options = api.getDeliveryDateOptions({
      sameDayEligible: productInfo?.dataset.deliverySameDay === 'true',
    });
    const todayButton = selector.querySelector('[data-delivery-quick-option="today"]');
    const nextButton = selector.querySelector('[data-delivery-quick-option="next"]');

    if (todayButton) {
      setButtonContent(todayButton, options.today);
      todayButton.deliveryCalendarDate = options.today.date;
    }

    if (nextButton) {
      setButtonContent(nextButton, options.next);
      nextButton.deliveryCalendarDate = options.next.date;
    }

    updateSelectedOption(selector);
  }

  function initializeDeliverySelector(selector) {
    refreshDeliverySelector(selector);
    if (selector.dataset.casaDeliveryInitialized === 'true') return;

    selector.querySelectorAll('[data-delivery-quick-option]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || !button.deliveryCalendarDate) return;
        getDeliveryApi()?.selectDeliveryDate(button.deliveryCalendarDate, getPicker(selector));
        updateSelectedOption(selector);
      });
    });

    selector.querySelector('[data-delivery-calendar-option]')?.addEventListener('click', () => {
      const picker = getPicker(selector);
      if (!picker || !window.jQuery?.fn?.datepicker) return;

      updateSelectedOption(selector, 'calendar');
      window.jQuery(picker).datepicker('show');
    });

    selector.dataset.casaDeliveryInitialized = 'true';
  }

  function initializeCasaProduct(root = document) {
    const selectors = [];
    if (root instanceof Element && root.matches('[data-casa-delivery-selector]')) selectors.push(root);
    if (root?.querySelectorAll) selectors.push(...root.querySelectorAll('[data-casa-delivery-selector]'));
    selectors.forEach(initializeDeliverySelector);
  }

  document.addEventListener('casa:delivery-date-selected', (event) => {
    const selector = event.target.closest?.('[data-casa-delivery-selector]');
    if (selector) updateSelectedOption(selector);
  });

  document.addEventListener('casa:delivery-availability-refreshed', () => initializeCasaProduct(document));
  document.addEventListener('shopify:section:load', (event) => initializeCasaProduct(event.target));
  document.addEventListener('product-info:loaded', (event) => initializeCasaProduct(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCasaProduct(document), { once: true });
  } else {
    initializeCasaProduct(document);
  }
})();
